import React, { useState } from 'react';

// ── Artist slides for KiNSTALLATION ──────────────────────────────────────────
const installationSlides = [
  {
    img: 'kin/assest/about/kininstallation/citra_novieta/art1.webp',
    artistImg: 'kin/assest/about/kininstallation/citra_novieta/citra_novieta.webp',
    artist: 'Citra & Novieta',
    artName: 'Mountain Song',
    tag: '4th Installation · Latest',
  },
  {
    img: 'kin/assest/about/kininstallation/eko/art1.webp',
    artistImg: 'kin/assest/about/kininstallation/eko/eko-nugroho.webp',
    artist: 'Eko Nugroho',
    artName: 'Save Our Future',
    tag: '3rd Installation',
  },
  {
    img: 'kin/assest/about/kininstallation/eldwin/art1.webp',
    artistImg: 'kin/assest/about/kininstallation/eldwin/eldwin-pradipta.webp',
    artist: 'Eldwin Pradipta',
    artName: 'Pola Pola Bejana',
    tag: '2nd Installation',
  },
  {
    img: 'kin/assest/about/kininstallation/mangmoel/art1.webp',
    artistImg: 'kin/assest/about/kininstallation/mangmoel/mangmole.webp',
    artist: 'Mulyana (Mang Moel)',
    artName: 'Imaji Laut Timur Nusantara',
    tag: '1st Installation',
  },
];

// ── Section config ────────────────────────────────────────────────────────────
const sections = [
  {
    tag: 'Art Experience',
    title: 'KiNSTALLATION',
    accentColor: 'bg-primary-main',
    accentText: 'text-primary-main',
    tagColor: 'text-primary-main',
    description:
      'Seasonal artist commissions you can touch, hug, and hold — a sensory art space designed to spark wonder and imagination in every visitor.',
    cta: 'Explore the Art Space',
    href: '/kinstallation',
    imgRight: false,
    scrollHint: '↓ scroll down for KiNTERACTIVE',
  },
  {
    tag: 'Play & Learn',
    title: 'KiNTERACTIVE',
    img: 'kin/assest/about/installation/nusantara-1.webp',
    accentColor: 'bg-secondary-main',
    accentText: 'text-secondary-main',
    tagColor: 'text-secondary-main',
    description:
      "Hands-on exhibitions for kids and families celebrating Indonesia's culture, nature, and diversity through playful, creative experiences.",
    cta: 'View Activity Gallery',
    href: '/kinteractive',
    imgRight: true,
    scrollHint: '↑ scroll up to go back',
  },
];

// ── Slider (used only for KiNSTALLATION) ─────────────────────────────────────
const InstallationSlider = () => {
  const [current, setCurrent] = useState(0);
  const total = installationSlides.length;
  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  return (
    <div className="relative w-full md:w-[52%] flex-shrink-0 overflow-hidden group/slider h-52 md:h-full">
      {/* Slides */}
      {installationSlides.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            idx === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}>
          <img src={slide.img} alt={slide.artName} className="w-full h-full object-cover" />

          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

          {/* Artist info — bottom of image */}
          <div className="absolute bottom-0 left-0 right-0 px-5 pb-6">
            {/* KiN logo + ordinal tag */}
            <div className="inline-flex items-center gap-2 bg-black/30 backdrop-blur-sm rounded-full px-3 py-1.5 mb-3">
              <img
                src="kin/assest/logo-svg-orange.png"
                alt="KiN"
                className="h-3.5 object-contain"
              />
              <span className="text-[9px] font-bold uppercase tracking-widest text-white/80">
                {slide.tag}
              </span>
            </div>

            {/* Art title */}
            <h4 className="text-base font-black text-white leading-tight mb-4">{slide.artName}</h4>

            {/* Artist identity row */}
            <div className="flex items-center gap-3">
              <img
                src={slide.artistImg}
                alt={slide.artist}
                className="w-14 h-14 rounded-full object-cover border-[3px] border-white shadow-lg flex-shrink-0"
              />
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-widest text-white/60 leading-none mb-1">
                  Artist
                </p>
                <p className="text-sm font-bold text-white leading-tight">{slide.artist}</p>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Prev / Next arrows (visible on hover) */}
      <button
        onClick={prev}
        className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 backdrop-blur-sm text-white text-lg leading-none flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity duration-200 hover:bg-black/50">
        ‹
      </button>
      <button
        onClick={next}
        className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 backdrop-blur-sm text-white text-lg leading-none flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity duration-200 hover:bg-black/50">
        ›
      </button>

      {/* Dot indicators */}
      <div className="absolute bottom-4 right-4 flex gap-1.5">
        {installationSlides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`rounded-full transition-all duration-300 ${
              idx === current ? 'w-4 h-1.5 bg-white' : 'w-1.5 h-1.5 bg-white/40 hover:bg-white/70'
            }`}
          />
        ))}
      </div>

      {/* Slide counter */}
      <div className="absolute top-4 right-4 text-[10px] font-bold text-white/60 tabular-nums">
        {current + 1} / {total}
      </div>
    </div>
  );
};

// ── Interactive slides for KiNTERACTIVE ──────────────────────────────────────
const interactiveSlides = [
  {
    img: 'kin/assest/about/kininteractive/pestariang1.webp',
    label: 'Pesta Riang Nusantara',
    subtitle: 'A Radiant of Nusantara Festival — culture, games & music.',
    tag: '3rd · Current',
  },
  {
    img: 'kin/assest/about/kininteractive/canva-1.webp',
    label: 'Canvas Of Future',
    subtitle: 'Participatory space for young future planners.',
    tag: '2nd',
  },
  {
    img: 'kin/assest/about/kininteractive/nusantara-1.webp',
    label: 'Jelajah Nusantara',
    subtitle: 'Rediscover the village — a journey through Nusantara.',
    tag: '1st',
  },
];

// ── Slider for KiNTERACTIVE ─────────────────────────────────────────────
const InteractiveSlider = () => {
  const [current, setCurrent] = useState(0);
  const total = interactiveSlides.length;
  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  return (
    <div className="relative w-full md:w-[52%] flex-shrink-0 overflow-hidden group/slider h-52 md:h-full md:order-2">
      {/* Slides */}
      {interactiveSlides.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            idx === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}>
          <img src={slide.img} alt={slide.label} className="w-full h-full object-cover" />

          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

          {/* Info overlay — bottom */}
          <div className="absolute bottom-0 left-0 right-0 px-5 pb-6">
            {/* KiN logo + ordinal tag */}
            <div className="inline-flex items-center gap-2 bg-black/30 backdrop-blur-sm rounded-full px-3 py-1.5 mb-3">
              <img
                src="kin/assest/logo-svg-orange.png"
                alt="KiN"
                className="h-3.5 object-contain"
              />
              <span className="text-[9px] font-bold uppercase tracking-widest text-white/80">
                {slide.tag}
              </span>
            </div>
            <h4 className="text-base font-black text-white leading-tight mb-1">{slide.label}</h4>
            <p className="text-xs text-white/60 leading-snug max-w-[220px]">{slide.subtitle}</p>
          </div>
        </div>
      ))}

      {/* Prev / Next arrows */}
      <button
        onClick={prev}
        className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 backdrop-blur-sm text-white text-lg leading-none flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity duration-200 hover:bg-black/50">
        ‹
      </button>
      <button
        onClick={next}
        className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 backdrop-blur-sm text-white text-lg leading-none flex items-center justify-center opacity-0 group-hover/slider:opacity-100 transition-opacity duration-200 hover:bg-black/50">
        ›
      </button>

      {/* Dot indicators */}
      <div className="absolute bottom-4 right-4 flex gap-1.5">
        {interactiveSlides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`rounded-full transition-all duration-300 ${
              idx === current ? 'w-4 h-1.5 bg-white' : 'w-1.5 h-1.5 bg-white/40 hover:bg-white/70'
            }`}
          />
        ))}
      </div>

      {/* Slide counter */}
      <div className="absolute top-4 right-4 text-[10px] font-bold text-white/60 tabular-nums">
        {current + 1} / {total}
      </div>
    </div>
  );
};

// ── Main component ────────────────────────────────────────────────────────────
const HomeFeatures = React.forwardRef(({ activeSection = 0, onSectionChange }, ref) => {
  return (
    <div ref={ref} className="flex" style={{ height: 'calc(100vh - 60px)' }}>
      {/* ── Left Sidebar Tabs ── */}
      <div className="w-20 sm:w-28 md:w-44 lg:w-64 flex-shrink-0 border-r border-gray-100 flex flex-col justify-center gap-2 px-3 md:px-4 lg:px-6">
        {sections.map((s, i) => (
          <button
            key={i}
            onClick={() => onSectionChange && onSectionChange(i)}
            className="group flex items-center gap-4 py-7 px-3 rounded-2xl text-left w-full hover:bg-gray-50/80 transition-colors duration-200">
            {/* Accent bar */}
            <div
              className={`w-1 h-14 rounded-full flex-shrink-0 transition-all duration-300 ${
                activeSection === i ? s.accentColor : 'bg-gray-200'
              }`}
            />
            <div className="min-w-0">
              <p
                className={`text-xs font-black tracking-widest transition-colors duration-300 ${
                  activeSection === i ? s.tagColor : 'text-gray-300'
                }`}>
                0{i + 1}
              </p>
              <p
                className={`hidden md:block text-base font-black tracking-tight leading-tight mt-1 transition-colors duration-300 ${
                  activeSection === i ? 'text-kin-textdark' : 'text-kin-text/40'
                }`}>
                {s.title}
              </p>
            </div>
          </button>
        ))}

        {/* Progress dots — small screens only */}
        <div className="flex md:hidden flex-col items-center gap-2 mt-6">
          {sections.map((s, i) => (
            <button
              key={i}
              onClick={() => onSectionChange && onSectionChange(i)}
              className={`rounded-full transition-all duration-300 ${
                activeSection === i ? `w-2 h-6 ${s.accentColor}` : 'w-2 h-2 bg-gray-200'
              }`}
            />
          ))}
        </div>
      </div>

      {/* ── Sliding Panel Track ── */}
      <div className="flex-1 overflow-hidden">
        <div
          className="transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateY(${activeSection === 1 ? 'calc(-100vh + 60px)' : '0'})`,
          }}>
          {sections.map((s, i) => (
            <div
              key={i}
              className="flex flex-col md:flex-row"
              style={{ height: 'calc(100vh - 60px)' }}>
              {/* Image — slider for section 0 and 1 */}
              {i === 0 ? <InstallationSlider /> : <InteractiveSlider />}

              {/* Content */}
              <div
                className={`flex-1 flex flex-col justify-center px-7 lg:px-14 py-6 lg:py-0 ${
                  s.imgRight ? 'md:order-1' : ''
                }`}>
                <span
                  className={`text-[10px] uppercase font-black tracking-[0.35em] ${s.tagColor} mb-4`}>
                  {s.tag}
                </span>
                <div className={`h-[2px] w-10 ${s.accentColor} rounded-full mb-4`} />
                <h3 className="text-3xl lg:text-[2.6rem] font-black text-kin-textdark tracking-tight leading-none mb-5">
                  {s.title}
                </h3>
                <p className="text-sm text-kin-text leading-relaxed max-w-sm mb-8">
                  {s.description}
                </p>
                <a
                  href={s.href}
                  className={`inline-flex items-center gap-2 text-sm font-bold ${s.accentText} self-start group/link`}>
                  {s.cta}
                  <svg
                    className="w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-200"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2.5}>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </a>
                <p className="text-[10px] text-kin-text/30 mt-10 tracking-wide">{s.scrollHint}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

HomeFeatures.displayName = 'HomeFeatures';

export default HomeFeatures;
